// Base API URL - adjust this based on your environment
const getApiUrl = () => {
    switch (process.env.REACT_APP_ENV) {
      case 'production':
        return process.env.REACT_APP_API_URL || 'https://your-production-api.com';
      default:
        return process.env.REACT_APP_API_URL || 'http://localhost:8080';
    }
  };
  
  export const API_URL = getApiUrl();

  // In-app brand name (landing page, footer, etc.) — separate knob from the
  // browser tab title / PWA name in public/index.html, which is filled in
  // directly at build time via CRA's %REACT_APP_BRAND_NAME% interpolation.
  // Has a JS-level fallback (unlike index.html's), so it's safe even if a
  // build forgets to set the env var.
  export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || 'Explosion Social';

  // In-app logo (navbar, sidebar). Same knob pattern as BRAND_NAME above —
  // falls back to the existing ESX logo so builds that don't set this are
  // unaffected. Point it at a file placed in public/ (e.g. /toolvids_logo.png).
  export const LOGO_PATH = process.env.REACT_APP_LOGO_PATH || '/logo.jpg';

  // Account Automation always calls ESX's live production backend
  // regardless of what this dashboard is otherwise pointed at (see
  // services/automationApi.js) — meaningless/unwanted for a build like
  // toolvids that has no such production backend. Defaults to enabled so
  // ESX is unaffected; set REACT_APP_ENABLE_ACCOUNT_AUTOMATION=false to hide
  // the nav item and route.
  export const ENABLE_ACCOUNT_AUTOMATION = process.env.REACT_APP_ENABLE_ACCOUNT_AUTOMATION !== 'false';

  export const endpoints = {
    signin: `${API_URL}/auth/signin`,
    signup: `${API_URL}/auth/signup`,
    // resetpPassword: `${API_URL}/auth/reset-password`,
  
  }; 